export interface Project {
  id: number;
  title: string;
  category: 'landing' | 'institucional' | 'catalogo';
  description: string;
  image: string;
  results: string;
  tech: string[];
  link: string;
}

export const projects: Project[] = [
  {
    id: 1,
    title: 'Forma Ambiental',
    category: 'institucional',
    description: 'Site institucional',
    image: '/images/forma.png',
    results: '',
    tech: [],
    link: 'https://formaambiental.com.br/',
  },
  {
    id: 2,
    title: 'GreenPlus',
    category: 'landing',
    description: 'Sistema para coleta de resíduo',
    image: '/images/greenplus.png',
    results: '',
    tech: [],
    link: 'https://greenplus.com.br',
  },
  {
    id: 3,
    title: 'Getalk',
    category: 'landing',
    description: 'Site para divulgação de produto',
    image: '/images/gtalk.png',
    results: '',
    tech: [],
    link: 'https://getalk.com.br',
  },
  {
    id: 4,
    title: 'Feira Certa',
    category: 'landing',
    description: 'Site para divulgação de produto',
    image: '/images/feira.png',
    results: '',
    tech: [],
    link: 'https://feiracerta.com.br',
  },
  {
    id: 5,
    title: 'Drone Agrícola',
    category: 'institucional',
    description: 'Divulgação de serviço de drone de pulverização',
    image: '/images/drone.png',
    results: '',
    tech: [],
    link: 'https://drone.genesystecnologia.com.br/',
  }
];

// Função para adicionar novo projeto facilmente
export const addProject = (newProject: Omit<Project, 'id'>): Project => {
  const id = Math.max(...projects.map(p => p.id)) + 1;
  const project = { ...newProject, id };
  projects.push(project);
  return project;
};